export class BlackListedTokenError extends Error {
  readonly contextId: string;
  constructor(contextId: string) {
    super('Black listed token');
    this.name = 'BlackListedTokenError';
    this.contextId = contextId;
  }
}
